<template>
  <div>
    <b-modal
      ref="editContact"
      :title="$t('contacts.editContact')"
      size="sm"
      dialog-class="message-info-modal"
      hide-footer
      hide-backdrop
      v-if="windowWidth < 800"
      >
      <div style="text-align: center;">
        <b-alert variant="danger" style="font-size: 0.7rem;" :show="contactError.length > 0">{{ contactError }}</b-alert>
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text" style="padding: .1rem .75rem !important;"><i class="mdi mdi-account" aria-hidden="true"></i></span>
          </b-input-group-prepend>
          <b-form-input v-model="full_name" size="sm" :placeholder="$t('contacts.fullName')">
          </b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text" style="padding: .1rem .75rem !important;"><i class="mdi mdi-phone" aria-hidden="true"></i></span>
          </b-input-group-prepend>
          <b-form-input v-model="phone" size="sm" :placeholder="$t('contacts.phonenumber')">
          </b-form-input>
        </b-input-group>
        <b-button class="save-button" @click="saveContact">
          {{ $t('contacts.save') }}
        </b-button>
      </div>
    </b-modal>
    <b-modal
      ref="editContact"
      :title="$t('contacts.editContact')"
      size="sm"
      hide-footer
      hide-backdrop
      v-else
      >
      <div style="text-align: center;">
        <b-alert variant="danger" style="font-size: 0.7rem;" :show="contactError.length > 0">{{ contactError }}</b-alert>
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text" style="padding: .1rem .75rem !important;"><i class="mdi mdi-account" aria-hidden="true"></i></span>
          </b-input-group-prepend>
          <b-form-input v-model="full_name" size="sm" :placeholder="$t('contacts.fullName')">
          </b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text" style="padding: .1rem .75rem !important;"><i class="mdi mdi-phone" aria-hidden="true"></i></span>
          </b-input-group-prepend>
          <b-form-input v-model="phone" size="sm" :placeholder="$t('contacts.phonenumber')">
          </b-form-input>
        </b-input-group>
        <b-button class="save-button" @click="saveContact">
          {{ $t('contacts.save') }}
        </b-button>
      </div>
    </b-modal>
    <b-modal
      ref="addContact"
      :title="$t('contacts.addContact')"
      size="sm"
      dialog-class="message-info-modal"
      hide-footer
      hide-backdrop
      v-if="windowWidth < 800"
      >
      <div style="text-align: center;">
        <b-alert variant="danger" style="font-size: 0.7rem;" :show="contactError.length > 0">{{ contactError }}</b-alert>
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text" style="padding: .1rem .75rem !important;"><i class="mdi mdi-account" aria-hidden="true"></i></span>
          </b-input-group-prepend>
          <b-form-input v-model="full_name" size="sm" :placeholder="$t('contacts.fullName')">
          </b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text" style="padding: .1rem .75rem !important;"><i class="mdi mdi-phone" aria-hidden="true"></i></span>
          </b-input-group-prepend>
          <b-form-input v-model="phone" size="sm" :placeholder="$t('contacts.phonenumber')">
          </b-form-input>
        </b-input-group>
        <b-button class="save-button" @click="addContact">
          {{ $t('contacts.save') }}
        </b-button>
      </div>
    </b-modal>
    <b-modal
      ref="addContact"
      :title="$t('contacts.addContact')"
      size="sm"
      hide-footer
      hide-backdrop
      v-else
      >
      <div style="text-align: center;">
        <b-alert variant="danger" style="font-size: 0.7rem;" :show="contactError.length > 0">{{ contactError }}</b-alert>
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text" style="padding: .1rem .75rem !important;"><i class="mdi mdi-account" aria-hidden="true"></i></span>
          </b-input-group-prepend>
          <b-form-input v-model="full_name" size="sm" :placeholder="$t('contacts.fullName')">
          </b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text" style="padding: .1rem .75rem !important;"><i class="mdi mdi-phone" aria-hidden="true"></i></span>
          </b-input-group-prepend>
          <b-form-input v-model="phone" size="sm" :placeholder="$t('contacts.phonenumber')">
          </b-form-input>
        </b-input-group>
        <b-button class="save-button" @click="addContact">
          {{ $t('contacts.save') }}
        </b-button>
      </div>
    </b-modal>
    <b-modal
      ref="deleteContact"
      :title="$t('contacts.deleteContact')"
      size="sm"
      dialog-class="message-info-modal"
      hide-footer
      hide-backdrop
      v-if="windowWidth < 800"
      >
      <div style="text-align: center;">
        {{ $t('contacts.deleteQuestion') }} {{ full_name }}?
        <b-button class="mt-2" variant="outline-secondary" block @click="cancelDeleteContact">{{ $t('contacts.cancel') }}</b-button>
        <b-button class="mt-2" variant="danger" block @click="deleteContact">{{ $t('contacts.delete') }}</b-button>
      </div>
    </b-modal>
    <b-modal
      ref="deleteContact"
      :title="$t('contacts.deleteContact')"
      size="sm"
      hide-footer
      hide-backdrop
      v-else
      >
      <div style="text-align: center;">
        {{ $t('contacts.deleteQuestion') }} {{ full_name }}?
        <b-button class="mt-2" variant="outline-secondary" block @click="cancelDeleteContact">{{ $t('contacts.cancel') }}</b-button>
        <b-button class="mt-2" variant="danger" block @click="deleteContact">{{ $t('contacts.delete') }}</b-button>
      </div>
    </b-modal>
    <div class="contacts-row" style="padding: 5px auto; margin-bottom: 0 !important; margin-top: 0 !important; background-color: #F7F7F7;">
      <i class="mdi mdi-contacts" aria-hidden="true"></i>&nbsp;{{ $t('contacts.contacts') }}
    </div>
    <div class="contacts-row" style="padding: 5px auto; margin-bottom: 0 !important; margin-top: 0 !important;">
      <b-input-group>
        <b-input-group-prepend>
          <span class="input-group-text" style="padding: .1rem .75rem !important;"><i class="mdi mdi-magnify" aria-hidden="true"></i></span>
        </b-input-group-prepend>
        <b-form-input style="border-right: 0;" v-model="search" @keyup="performSearch" size="sm" :placeholder="$t('contacts.search')">
        </b-form-input>
        <b-input-group-append v-if="search.length > 0">
          <span class="input-group-text" style="padding: .1rem 0 !important; cursor: pointer; background-color: transparent; border-left: 0;" @click="clearSearch"><i class="mdi mdi-close" aria-hidden="true"></i></span>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div class="row contacts-row" style="padding: 5px auto; margin-bottom: 0 !important; margin-top: 0 !important;" v-if="!disableDirectory">
      <div :class="['col-sm-6', { 'contact-menu-active': isDirectory }, 'contact-menu']" @click="directoryTab">
        {{ $t('contacts.directory') }}
      </div>
      <div :class="['col-sm-6', { 'contact-menu-active': isContacts }, 'contact-menu']" @click="contactsTab">
        {{ $t('contacts.contacts') }}
      </div>
    </div>
    <div style="height: 465px; width: 240px; overflow-y: scroll; padding: 0 20px; text-align: center; background-color: #FFFFFF;">
      <div v-if="sortedSpeeddials && isDirectory">
        <div v-if="searchedSpeeddials">
          <div class="contacts-row" v-for="(sp, i) in searchedSpeeddials" :key="`speeddial${i}`">
            <span>
              <text-highlight :queries="queries" :highlightStyle="highlightStyle">{{ sp.label }}</text-highlight>
              <br /><span style="cursor: pointer;" @click="selectNumber(sp.speed_dial)"><text-highlight :queries="queries" :highlightStyle="highlightStyle">{{ sp.speed_dial }}</text-highlight></span>
              <br />
            </span>
            <i class="mdi mdi-video" style="color: #007bff; cursor: pointer;" v-tooltip="$t('contacts.videoCall')" aria-hidden="true" @click="makeVideoCall(sp.speed_dial)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-phone" style="color: #28a745; cursor: pointer;" v-tooltip="$t('contacts.voiceCall')" aria-hidden="true" @click="makeCall(sp.speed_dial)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-message" style="color: #8500a7; cursor: pointer;" v-tooltip="$t('contacts.message')" aria-hidden="true" @click="sendMessage(sp.speed_dial)"></i>
          </div>
        </div>
        <div v-else>
          <div class="contacts-row" v-for="(sp, i) in sortedSpeeddials" :key="`speeddial${i}`">
            <span>
              <span>{{ sp.label }}</span>
              <br /><span style="cursor: pointer;" @click="selectNumber(sp.speed_dial)">{{ sp.speed_dial }}</span>
              <br />
            </span>
            <i class="mdi mdi-video" style="color: #007bff; cursor: pointer;" v-tooltip="$t('contacts.videoCall')" aria-hidden="true" @click="makeVideoCall(sp.speed_dial)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-phone" style="color: #28a745; cursor: pointer;" v-tooltip="$t('contacts.voiceCall')" aria-hidden="true" @click="makeCall(sp.speed_dial)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-message" style="color: #8500a7; cursor: pointer;" v-tooltip="$t('contacts.message')" aria-hidden="true" @click="sendMessage(sp.speed_dial)"></i>
          </div>
        </div>
      </div>
      <div class="contacts-row" v-if="!speeddials && isDirectory">
        <b-spinner small variant="teal" label="Spinning"></b-spinner>
      </div>
      <div v-if="sortedContacts && isContacts">
        <div class="contacts-row">
          <span class="contact-edit text-teal" @click="openAddContact">&plus; {{ $t('contacts.newContact') }}</span>
        </div>
        <div v-if="searchedContacts">
          <div class="contacts-row" v-for="(c, i) in searchedContacts" :key="`contact${i}`">
            <span>
              <text-highlight :queries="queries" :highlightStyle="highlightStyle">{{ c.full_name }}</text-highlight>
              <br /><span style="cursor: pointer;" @click="selectNumber(c.phone)"><text-highlight :queries="queries" :highlightStyle="highlightStyle">{{ c.phone }}</text-highlight></span>
              <br />
            </span>
            <i class="mdi mdi-video" style="color: #007bff; cursor: pointer;" v-tooltip="$t('contacts.videoCall')" aria-hidden="true" @click="makeVideoCall(c.phone)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-phone" style="color: #28a745; cursor: pointer;" v-tooltip="$t('contacts.voiceCall')" aria-hidden="true" @click="makeCall(c.phone)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-message" style="color: #8500a7; cursor: pointer;" v-tooltip="$t('contacts.message')" aria-hidden="true" @click="sendMessage(c.phone)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-pencil" style="color: #d6d610; cursor: pointer;" v-tooltip="$t('contacts.edit')" aria-hidden="true" @click="openEditContact(c)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-delete" style="color: red; cursor: pointer;" v-tooltip="$t('contacts.delete')" aria-hidden="true" @click="openDeleteContact(c)"></i>
          </div>
        </div>
        <div v-else>
          <div class="contacts-row" v-for="(c, i) in sortedContacts" :key="`contact${i}`">
            <span>
              <span>{{ c.full_name }}</span>
              <br /><span style="cursor: pointer;" @click="selectNumber(c.phone)">{{ c.phone }}</span>
              <br />
            </span>
            <i class="mdi mdi-video" style="color: #007bff; cursor: pointer;" v-tooltip="$t('contacts.videoCall')" aria-hidden="true" @click="makeVideoCall(c.phone)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-phone" style="color: #28a745; cursor: pointer;" v-tooltip="$t('contacts.voiceCall')" aria-hidden="true" @click="makeCall(c.phone)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-message" style="color: #8500a7; cursor: pointer;" v-tooltip="$t('contacts.message')" aria-hidden="true" @click="sendMessage(c.phone)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-pencil" style="color: #d6d610; cursor: pointer;" v-tooltip="$t('contacts.edit')" aria-hidden="true" @click="openEditContact(c)"></i>&nbsp;&nbsp;
            <i class="mdi mdi-delete" style="color: red; cursor: pointer;" v-tooltip="$t('contacts.delete')" aria-hidden="true" @click="openDeleteContact(c)"></i>
          </div>
        </div>
      </div>
      <div class="contacts-row" v-else-if="!contacts && isContacts">
        <b-spinner small variant="teal" label="Spinning"></b-spinner>
      </div>
      <div v-else-if="!sortedContacts && isContacts">
        <div class="contacts-row">
          <span class="contact-edit text-teal" @click="openAddContact">&plus; {{ $t('contacts.newContact') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextHighlight from 'vue-text-highlight'

export default {
  name: 'Contacts',
  components: {
    'text-highlight': TextHighlight
  },
  props: {
    makeVideoCall: {
      type: Function
    },
    makeCall: {
      type: Function
    },
    selectNumber: {
      type: Function
    },
    extension: {
      type: String,
      required: false
    },
    contacts: {
      type: Array
    },
    sortedContacts: {
      type: Array
    },
    speeddials: {
      type: Array
    },
    sortedSpeeddials: {
      type: Array
    },
    sendMessage: {
      type: Function
    },
    updateContact: {
      type: Function
    },
    newContact: {
      type: Function
    },
    removeContact: {
      type: Function
    },
    disableSpeedDial: {
      type: Boolean
    },
    disableDirectory: {
      type: Boolean
    }
  },
  data () {
    return {
      searchedSpeeddials: null,
      searchedContacts: null,
      search: '',
      queries: [],
      highlightStyle: { 'background-color': 'white', color: '#167bff', 'font-size': '1.15rem' },
      isContacts: this.disableDirectory,
      isDirectory: !this.disableDirectory,
      windowWidth: window.innerWidth,
      full_name: '',
      phone: '',
      selectedContact: null,
      contactError: ''
    }
  },
  methods: {
    performSearch () {
      var self = this
      if (self.search.length <= 0) {
        self.searchedSpeeddials = self.sortedSpeeddials
        self.searchedContacts = self.sortedContacts
        self.queries = []
      } else {
        var tempSpeeddials = []
        var tempContacts = []
        self.queries = []

        self.speeddials.forEach ((speeddial) => {
          if (speeddial.speed_dial.toLowerCase().indexOf(self.search.toLowerCase()) != -1 || speeddial.label.toLowerCase().indexOf(self.search.toLowerCase()) != -1) {
            tempSpeeddials.push(speeddial)
          }
        })

        self.contacts.forEach ((contact) => {
          if (contact.phone.toLowerCase().indexOf(self.search.toLowerCase()) != -1 || contact.full_name.toLowerCase().indexOf(self.search.toLowerCase()) != -1) {
            tempContacts.push(contact)
          }
        })

        self.searchedSpeeddials = tempSpeeddials.slice(0).sort((a, b) => parseInt(a.speed_dial) < parseInt(b.speed_dial) ? -1 : 1 )
        self.searchedContacts = tempContacts.slice(0).sort((a, b) => a.full_name < b.full_name ? -1 : 1 )
        self.queries.push(self.search)
      }
    },
    clearSearch () {
      var self = this
      self.searchedSpeeddials = self.speeddials.slice(0).sort((a, b) => parseInt(a.speed_dial) < parseInt(b.speed_dial) ? -1 : 1 )
      self.searchedContacts = self.contacts.slice(0).sort((a, b) => a.full_name < b.full_name ? -1 : 1 )
      self.queries = []
      self.search = ''
    },
    contactsTab () {
      var self = this
      self.isContacts = true
      self.isDirectory = false
    },
    directoryTab () {
      var self = this
      self.isDirectory = true
      self.isContacts = false
    },
    openEditContact (contact) {
      var self = this
      self.contactError = ''
      self.full_name = contact.full_name
      self.phone = contact.phone
      self.selectedContact = contact
      self.$refs['editContact'].show()
    },
    openDeleteContact (contact) {
      var self = this
      self.full_name = contact.full_name
      self.phone = contact.phone
      self.selectedContact = contact
      self.$refs['deleteContact'].show()
    },
    cancelDeleteContact () {
      var self = this
      self.full_name = ''
      self.phone = ''
      self.selectedContact = null
      self.$refs['deleteContact'].hide()
    },
    openAddContact () {
      var self = this
      self.contactError = ''
      self.full_name = ''
      self.phone = ''
      self.selectedContact = null
      self.$refs['addContact'].show()
    },
    saveContact () {
      var self = this
      self.contactError = ''
      if (self.validateContact()) {
        self.$refs['editContact'].hide()
        self.updateContact(self.selectedContact, self.full_name, self.phone)
        self.full_name = ''
        self.phone = ''
      } else {
        self.validateContact()
      }
    },
    addContact () {
      var self = this
      self.contactError = ''
      if (self.validateContact()) {
        self.$refs['addContact'].hide()
        self.newContact(self.full_name, self.phone)
        self.full_name = ''
        self.phone = ''
      } else {
        self.validateContact()
      }
    },
    deleteContact () {
      var self = this
      self.$refs['deleteContact'].hide()
      self.removeContact(self.selectedContact)
      self.full_name = ''
      self.phone = ''
      self.selectedContact = null
    },
    validateContact () {
      var self = this
      if (self.full_name.length < 3) {
        self.contactError = self.$t('contacts.contactError1')
        return false
      } else if (self.phone.length < 1 || self.phone.length > 20 || !/^[+]?\d+$/.test(self.phone)) {
        self.contactError = self.$t('contacts.contactError2')
        return false
      } else {
        self.contactError = ''
        return true
      }
    }
  }
}

</script>

<style>
.contacts-row {
  margin: 20px auto !important;
  width: auto;
  max-width: 420px !important;
  height: auto !important;
  clear: both !important;
  text-align: center !important;
}
.text-teal {
  color: #009AB1;
}
.contact-menu-active {
  background-color: #e9ecef !important;
}
.contact-menu{
  background-color: #F7F7F7;
  line-height: 31px;
}
.contact-menu:hover {
  cursor: pointer;
  background-color: #e9ecef;
}

.message-info-modal {
  margin-right: 4px !important;
  max-width: 230px !important;
}

.contact-edit:hover {
  cursor: pointer;
  color: #009AB1;
}

.save-button {
  margin-top: 5px;
  background-color: #009AB1 !important;
  border-color: #009AB1 !important;
}
</style>
